import {
  Box,
  Divider,
  Drawer,
  IconButton,
  List,
  ListItem,
  ListItemButton,
  ListItemText,
  Stack,
} from "@mui/material"
import { NavLink } from "react-router-dom"
import AppTheme from "../../style/theme/main"

import { FaChevronCircleRight, FaTimes } from "react-icons/fa"

import logoDark from "../../images/general/logoDark.svg"

const links = [
  { title: "Home", to: "/" },
  { title: "About", to: "/about" },
  { title: "Service ", to: "/service" },
  { title: "Pricing  ", to: "/pricing" },
  { title: "Contact  ", to: "/contact" }
]

export default function AppDrawer({ open, close }) {
  return (
    <Drawer
      open={open}
      onClose={close}
      sx={{
        display: { xs: "block", md: "none" },
        "& .MuiDrawer-paper": {
          boxSizing: "border-box",
          width: "100%",
          maxWidth: "320px",
        },
      }}
    >
      <Stack
        // width="100%"
        direction={"row"}
        paddingX={"10px"}
        paddingY={"10px"}
        justifyContent="space-between"
        spacing="1px"
        mb={"16px"}
        alignItems={"center"}
      >
        <Box maxWidth={"60px"}>
          <img src={logoDark} alt="logo" height={40} />
        </Box>
        <IconButton onClick={close}>
          <FaTimes style={{ width: "24px", height: "24px" }} />
        </IconButton>
      </Stack>
      <List>
        {links.map((item) => (
          <NavLink
            to={item.to}
            key={item.title}
            style={({ isActive }) => ({
              textDecoration: "none",
              color: isActive ? AppTheme.palette.primary.main : "#111111",
            })}
          >
            <ListItem disablePadding>
              <ListItemButton>
                <ListItemText primary={item.title} />
              </ListItemButton>
            </ListItem>
            <Divider />
          </NavLink>
        ))}
            <ListItem disablePadding sx={{  bgcolor: AppTheme.palette.primary.main,color:"white"}} secondaryAction={
              <FaChevronCircleRight />
            }>
              <ListItemButton href="https://business.wallx.co" target="_blank" >
                <ListItemText primary={"Login"} />
              </ListItemButton>
            </ListItem>
            <ListItem disablePadding sx={{  color: AppTheme.palette.primary.main}} secondaryAction={
              <FaChevronCircleRight color={ AppTheme.palette.primary.main} />
            }>
              <ListItemButton >
                <ListItemText primary={"Get Started"} />
              </ListItemButton>
            </ListItem>
      </List>
    </Drawer>
  )
}
